import React from 'react';
import connect from "react-redux/es/connect/connect";


const TradeInLoader = ({isFetching}) => {
    return (
        <div className={isFetching ? 'loading loading-text' : 'clear'}>
            <div className="loading-trade-in">
                <div className="loading-trade-in__top-msg">…adding item to cart</div>
                <div className="loading-trade-in__bottom-msg">Sending you to the Trade screen</div>
            </div>
        </div>
    )
};


const mapStateToProps = (state) => {
    return {
        isFetching: state.tradeInReducer.show_trade_in_spinner
    }
};

export default connect(mapStateToProps)(TradeInLoader);
